/**
 * @generated SignedSource<<2de05c2a500d02a01ad3c17e5874b62c>>
 * @relayHash 8cd4dd08829f0cd78795100f6f2b3ffe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 061a57043279196465b7192567c37b22f52171f0cee776b71caf934cc0183567

import type { ConcreteRequest, Query } from 'relay-runtime';
export type DevAiFlowPipelinesStatus = "FAILED" | "IN_PROGRESS" | "PROVISIONED" | "STARTING" | "STOPPED" | "%future added value";
export type codeFrame_loadFlowQuery$variables = {
  cloudId: string;
  sessionId: string;
};
export type codeFrame_loadFlowQuery$data = {
  readonly devai_flowSessionGetByIDAndCloudID: {
    readonly createdAt: string | null | undefined;
    readonly id: string;
    readonly issueARI: string | null | undefined;
    readonly pipelines: ReadonlyArray<{
      readonly status: DevAiFlowPipelinesStatus | null | undefined;
      readonly url: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type codeFrame_loadFlowQuery = {
  response: codeFrame_loadFlowQuery$data;
  variables: codeFrame_loadFlowQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sessionId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "sessionId",
    "variableName": "sessionId"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "createdAt"
},
v5 = {
  "kind": "ScalarField",
  "name": "issueARI"
},
v6 = {
  "kind": "ScalarField",
  "name": "status"
},
v7 = {
  "kind": "ScalarField",
  "name": "url"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "codeFrame_loadFlowQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "DevAiFlowSession",
        "kind": "LinkedField",
        "name": "devai_flowSessionGetByIDAndCloudID",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "DevAiFlowPipeline",
            "kind": "LinkedField",
            "name": "pipelines",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "codeFrame_loadFlowQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "DevAiFlowSession",
        "kind": "LinkedField",
        "name": "devai_flowSessionGetByIDAndCloudID",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "DevAiFlowPipeline",
            "kind": "LinkedField",
            "name": "pipelines",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "061a57043279196465b7192567c37b22f52171f0cee776b71caf934cc0183567",
    "metadata": {},
    "name": "codeFrame_loadFlowQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2bc96ac28bcd7ae80590b68d7d72c94d";

export default node;
